import EventEmitter from 'eventemitter3';

const emitter = new EventEmitter();

export const handleUnCommittedData = () => {
  emitter.emit('commitData');
};

export default emitter;
